import { Wheat, Hammer, Coffee, Bike, Shield, Briefcase } from "lucide-react";
import { C } from "../kota/ui";

// Identitas visual tiap profesi: ikon, warna aksen (lembut, tetap dalam nuansa Jawsel), nama tempat kerja (scene)
export const PROFESI_UI = {
  petani: { Icon: Wheat, warna: "#2e9e5b", tempat: "Sawah" },
  tukang: { Icon: Hammer, warna: "#c27a1c", tempat: "Proyek" },
  barista: { Icon: Coffee, warna: "#8a5a3c", tempat: "Kedai Kopi" },
  ojol: { Icon: Bike, warna: "#0f8f8f", tempat: "Jalanan" },
  polisi: { Icon: Shield, warna: C.blue, tempat: "Alun-alun" },
};
export const uiProfesi = key => PROFESI_UI[key] || { Icon: Briefcase, warna: C.blue, tempat: "Kota" };
export const IKON_PROFESI = Object.fromEntries(Object.entries(PROFESI_UI).map(([k, v]) => [k, v.Icon]));

export const fmtMenit = s => (s >= 3600 ? `${Math.ceil(s / 3600)} jam` : `${Math.max(1, Math.ceil(s / 60))} mnt`);
export const fmtDetik = s => `${Math.floor(s / 60)}:${String(s % 60).padStart(2, "0")}`;
